import { useMutation, useQuery } from 'react-query'
import DataService from '../../../config/DataServices'
import { useToast } from '../../../hooks/usetoast'
import { useNavigate } from "react-router-dom";
import { queryClient } from '../../../config';
const { getRequest, postRequest } = DataService()


export const useSupportTicket = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/ticket/reply-ticket", data)
        },
    })
}

export const useGetTicketList = ({ page, size, search, type }) => {
    return useQuery({
        queryKey: ['get-support-his', page, size, search, type],
        queryFn: () => {
            return getRequest(`/ticket/ticket-history?page=${page}&size=${size}&search=${search}&status=${type}`)
        }
    })
}

export const useGetSingleTicketList = ({ id }) => {
    return useQuery({
        queryKey: ["single-detail", id],
        queryFn: () => {
            return getRequest(`/ticket/single-ticket?id=${id}`)
        }
    })
}

export const useSupportTicketStatus = () => {

    return useMutation({
        mutationFn: data => {
            return postRequest("/ticket/close-ticket", data)
        },
    })
}

//----------Ticket-Category-------------------//

export const useTicketCategories = ({ page, size, sortOrder, searchText, sortField }) => {
    return useQuery({
        queryKey: ["ticketscat", page, size, searchText, sortOrder, sortField],
        queryFn: () => {
            return getRequest(`/ticket/get-all-category?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}`);
        }
    });
}

export const useAddTicketCategory = () => {
    const toast = useToast();
    const navigate = useNavigate()
    return useMutation({
        mutationFn: (data) => {
            return postRequest("/ticket/add-category", { ...data })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("ticketscat");
            navigate('/ticket-category')
            return toast.success(success?.data?.message)
        }
    })
}

export const useDeleteTicketCategory = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest(`/ticket/delete-category/${data._id}`)
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("ticketscat");
            return toast.success(success?.data?.message)
        }
    })
}

export const useGetTicketCategory = (id) => {

    return useQuery({
        queryKey: ["get-category",],
        queryFn: () => {
            return getRequest(`/ticket/get-category/${id}`)
        }
    })
}

export const useUpdateCategory = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: (data) => {
            return postRequest(`/ticket/update-category/${data.id}`, { name: data.name })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("ticketscat");
            return toast.success(success?.data?.message)
        }
    })
}

export const useUpdateCategoryStatus = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: ({ status, _id }) => {
            return postRequest(`/ticket/update-category/${_id}`, { status })
        },
        onSuccess: success => {
            if (!success?.status) {
                return toast.error(success?.data?.message)
            }
            queryClient.refetchQueries("ticketscat");
            return toast.success(success?.data?.message)
        }
    })
}